import { Component, OnInit } from '@angular/core';
import { InsuranceService } from '../../../services/insurance.service';

@Component({
  selector: 'gtd-insurance-customers',
  templateUrl: './insurance-customers.component.html',
  styleUrls: ['./insurance-customers.component.scss']
})
export class InsuranceCustomersComponent implements OnInit {
  insurers$ = this.insuranceService.insurers$;
  constructor(private insuranceService: InsuranceService) {}

  ngOnInit() {}
}
